<template>
    <!--弹窗-->
    <el-dialog width="600px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="180px" size="mini">
            <div class="top">
                <div style="font-weight: 900;">下载模板</div>
                <div>
                    <a v-if="title == '上传词根数据'" href="/export/上传词根模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“上传词根”模板</a>
                    <a v-if="title == '上传否认词根数据'" href="/export/上传否认词根模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“上传否认词根”模板</a>
                    <a v-if="title == '上传已打广告词数据'" href="/export/上传已打广告词模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“上传已打广告词”模板</a>
                    <a v-if="title == '上传无效词数据'" href="/export/上传无效词模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“上传无效词”模板</a>
                    <a v-if="title == '上传种子词库数据'" href="/export/上传种子词库模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“上传种子词库”模板</a>
                    <a v-if="title == '上传词库排除数据'" href="/export/上传词库排除数据模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“上传词库排除数据”模板</a>
                    <a v-if="title == '上传核心词根数据'" href="/export/上传核心词根数据模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“上传核心词根数据”模板</a>
                </div>
            </div>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed='handExceed'
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件</div>
                </el-upload>
            </div>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(false)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/etyma/etyma";
export default {
    data() {
        return {
            loading: false,
            files: []
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
            });
            return;
        },
        handFileSuccess() {
            this.files = [];
            this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        submitForm() {
            this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
            if (this.files.length == 0) {
                this.$message.warning(`当前限制只能上传选择 1 个文件`);
                return;
            }
            let file = new FormData();
            file.append("file", this.files[0]);
            this.loading = true;
            let obj = {
                asin: this.formData.parent_asin,
                state:this.formData.state
            };
            let apis = null;
            if (this.title == "上传词根数据") {
                apis = api.etyma_file_upload;
            } else if (this.title == "上传否认词根数据") {
                apis = api.disavowal_etyma_file_upload;
            } else if (this.title == "上传已打广告词数据") {
                apis = api.ading_word_file_upload;
            } else if (this.title == "上传无效词数据") {
                apis = api.invalid_word_file_upload;
            } else if (this.title == "上传种子词库数据") {
                apis = api.seed_word_file_upload;
            } else if (this.title == "上传词库排除数据") {
                apis = api.eliminate_word_file_upload;
            } else if (this.title == "上传核心词根数据") {
                apis = api.core_etyma_file_upload;
            }
            apis(obj, file)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message: "上传成功"
                        });
                        this.handleClose();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请查看数据是否添加完成！"
                    });
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.handFileSuccess();
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
